var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1378 6.84499C21.2988 7.71478 20.454 8.58458 19.6091 9.46037C18.7643 10.3302 17.9311 11.2 17.1036 12.0518L14.2104 15.0451C13.9037 15.363 13.5913 15.6869 13.2846 16.0048L12.8043 16.5027C11.9826 17.3545 11.1378 18.2303 10.2988 19.0941C9.71435 19.694 9.15886 19.9939 8.60336 19.9939C8.06522 19.9939 7.53287 19.712 6.98316 19.1541C5.36296 17.4985 3.48237 15.5729 1.65386 13.6174C1.09258 13.0175 0.872692 12.2617 1.05786 11.5359C1.23145 10.834 1.75223 10.2942 2.48132 10.0662C2.66648 10.0062 2.85165 9.97625 3.03682 9.97625C3.55759 9.97625 4.05523 10.2222 4.55865 10.7321C5.15465 11.3379 5.75065 11.9558 6.32929 12.5616L6.98316 13.2395C7.28405 13.5514 7.59073 13.8633 7.89163 14.1753C8.01314 14.3012 8.14045 14.4152 8.29089 14.5532L8.35454 14.6132C8.44713 14.6971 8.5455 14.7811 8.64965 14.8831L8.7133 14.9431L8.77117 14.8831C9.24565 14.3792 9.72014 13.8813 10.1888 13.3835L10.5187 13.0355C11.4445 12.0518 12.3993 11.038 13.3424 10.0602L13.7822 9.59834C15.6281 7.67279 17.5376 5.67526 19.4703 3.71972C20.0663 3.11387 20.8127 2.87392 21.5129 3.07188C22.1899 3.25783 22.7049 3.8097 22.919 4.59552C23.1447 5.37533 22.9074 6.04718 22.1378 6.84499Z",
    fill: "#008000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordTick);
export default __webpack_public_path__ + "static/media/password_tick.2fbe9cad736d044c5424ea8d545c252c.svg";
export { ForwardRef as ReactComponent };